import { twMerge } from "tailwind-merge";
import { IconsProps } from ".";

export const UsersIcon = ({
  className = "text-primary",
  viewBox = "0 0 52 52",
  width = 52,
  height = 52,
  onClick,
}: IconsProps) => (
  <svg
    className={twMerge("cursor-pointer", className)}
    viewBox={viewBox}
    width={`${width}px`}
    height={`${height}px`}
    xmlns="http://www.w3.org/2000/svg"
    onClick={onClick}
    fill="none"
  >
    <title>UsersIcon</title>
    <path
      d="M45.5 42.7908C45.5 38.2626 41.8825 31.8103 36.8333 30.3826M32.5 42.791C32.5 37.0473 26.6797 29.791 19.5 29.791C12.3203 29.791 6.5 37.0473 6.5 42.791"
      stroke="currentColor"
      strokeWidth="3.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M32.5 22.209C36.0899 22.209 39 19.2988 39 15.709C39 12.1191 36.0899 9.20898 32.5 9.20898"
      stroke="currentColor"
      strokeWidth="3.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx="19.5"
      cy="15.166"
      r="6.5"
      stroke="currentColor"
      strokeWidth="3.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
